import { FleekError } from './FleekError';

type Values = {
  receivedValue: string;
  expectedValues: string[];
};

export class ExpectedOneOfValuesError extends FleekError<Values> {
  public name = 'ExpectedOneOfValuesError';

  toString = () => `Expected one of ${this.data.expectedValues.join(', ')} but got ${this.data.receivedValue}`;
}
